(function () {
  function initCarousel(carousel) {
    if (carousel.dataset.carouselReady === "true") return;

    const viewport = carousel.querySelector("[data-carousel-viewport]");
    const slides = Array.from(carousel.querySelectorAll("[data-carousel-slide]"));
    const previous = carousel.querySelector("[data-carousel-previous]");
    const next = carousel.querySelector("[data-carousel-next]");
    const status = carousel.querySelector("[data-carousel-status]");

    if (!viewport || slides.length < 2 || !previous || !next) return;

    carousel.dataset.carouselReady = "true";
    let currentIndex = 0;

    function slidePosition(slide) {
      return slide.offsetLeft - slides[0].offsetLeft;
    }

    function updateControls() {
      const nearestIndex = slides.reduce(function (nearest, slide, index) {
        const nearestDistance = Math.abs(slidePosition(slides[nearest]) - viewport.scrollLeft);
        const distance = Math.abs(slidePosition(slide) - viewport.scrollLeft);
        return distance < nearestDistance ? index : nearest;
      }, 0);

      currentIndex = nearestIndex;
      previous.disabled = currentIndex === 0;
      next.disabled = currentIndex === slides.length - 1;
      if (status) status.textContent = currentIndex + 1 + " / " + slides.length;
    }

    function goToSlide(index) {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      viewport.scrollTo({ left: slidePosition(slides[safeIndex]), behavior: "smooth" });
    }

    previous.addEventListener("click", function () {
      goToSlide(currentIndex - 1);
    });

    next.addEventListener("click", function () {
      goToSlide(currentIndex + 1);
    });

    viewport.addEventListener("scroll", updateControls, { passive: true });
    viewport.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goToSlide(currentIndex - 1);
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        goToSlide(currentIndex + 1);
      }
    });

    window.addEventListener("resize", updateControls);
    updateControls();
  }

  function updateVariant(form) {
    const select = form.querySelector("[data-new-arrivals-variant]");
    const price = form.querySelector("[data-new-arrivals-price]");
    const button = form.querySelector("[data-new-arrivals-add]");
    if (!select || !button) return;

    const selected = select.options[select.selectedIndex];
    const available = selected && selected.dataset.available === "true";

    if (price && selected) price.textContent = selected.dataset.price;
    button.disabled = !available;
    button.textContent = available ? button.dataset.defaultLabel : "Sold out";
  }

  async function submitProductForm(event, section) {
    event.preventDefault();

    const form = event.currentTarget;
    const button = form.querySelector("[data-new-arrivals-add]");
    const status = form.querySelector("[data-new-arrivals-form-status]");
    if (!button || button.disabled) return;

    const defaultLabel = button.dataset.defaultLabel || "Add to cart";
    button.disabled = true;
    button.textContent = "Adding…";
    button.setAttribute("aria-busy", "true");
    if (status) {
      status.textContent = "";
      status.classList.remove("is-error");
    }

    document.dispatchEvent(new CustomEvent("cart:drawer:loading", {
      detail: { message: "Adding to your cart…" },
    }));

    try {
      const response = await fetch(section.dataset.cartAddUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: new FormData(form),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.description || "This item could not be added.");

      button.textContent = "Added ✓";
      if (status) status.textContent = result.product_title + " is in your cart.";
      document.dispatchEvent(new CustomEvent("cart:drawer:open"));

      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = defaultLabel;
      }, 1600);
    } catch (error) {
      button.disabled = false;
      button.textContent = defaultLabel;
      if (status) {
        status.textContent = error.message;
        status.classList.add("is-error");
      }
      document.dispatchEvent(new CustomEvent("cart:drawer:error", {
        detail: { message: error.message || "This item could not be added to your cart." },
      }));
    } finally {
      button.removeAttribute("aria-busy");
    }
  }

  function initSection(section) {
    if (section.dataset.newArrivalsReady === "true") return;
    section.dataset.newArrivalsReady = "true";

    section.querySelectorAll("[data-new-arrivals-carousel]").forEach(initCarousel);

    section.querySelectorAll("[data-new-arrivals-product-form]").forEach(function (form) {
      const select = form.querySelector("[data-new-arrivals-variant]");
      if (select) select.addEventListener("change", function () { updateVariant(form); });
      form.addEventListener("submit", function (event) { submitProductForm(event, section); });
      updateVariant(form);
    });
  }

  function initAll() {
    document.querySelectorAll("[data-new-arrivals-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target.querySelector("[data-new-arrivals-section]");
    if (section) initSection(section);
  });
})();
